module.exports = __webpack_public_path__ + "static/7-3f1d3d13e233b5be00e5285141e38d93.jpg";